import { DomainList, DomainListIO } from '@core/domains/destination/domain-list/domain-list';
import { Destination } from '@core/domains/destination/destination';

export type DefaultAction = 'allow' | 'deny' | 'deny-unknown' | 'override-unknown';

export interface ClientConfigIO {
  default_action: DefaultAction;
  policy_order: string[];
  tls_is_active: boolean;
  antivirus_is_active: boolean;
  tls_excluded_theme_ids: string[];
  tls_excluded_category_ids: string[];
  tls_excluded_domain_list_ids: string[];
  tls_excluded_domain_lists: DomainListIO[];
}

export class ClientConfig {
  private _exclusions: Destination[];
  default_action: DefaultAction;
  policy_order: string[];
  tls_is_active: boolean;
  antivirus_is_active: boolean;
  tls_excluded_theme_ids: string[];
  tls_excluded_category_ids: string[];
  tls_excluded_domain_list_ids: string[];
  tls_excluded_domain_lists: Destination<DomainList>[];

  constructor(json: ClientConfigIO) {
    this.default_action = json?.default_action ?? 'deny';
    this.policy_order = json?.policy_order ?? [];
    this.tls_is_active = json?.tls_is_active ?? false;
    this.antivirus_is_active = json?.antivirus_is_active ?? true;
    this.tls_excluded_category_ids = json?.tls_excluded_category_ids ?? [];
    this.tls_excluded_theme_ids = json?.tls_excluded_theme_ids ?? [];
    this.tls_excluded_domain_list_ids = json?.tls_excluded_domain_list_ids ?? [];
    this.tls_excluded_domain_lists = json?.tls_excluded_domain_lists?.map((dl: DomainListIO) => new DomainList(dl)) ?? [];
  }

  get exclusions(): Destination[] {
    return this._exclusions;
  }

  set exclusions(list: Destination[]) {
    this._exclusions = list;
  }

  get length(): number {
    return this.tls_excluded_category_ids.length + this.tls_excluded_domain_list_ids.length + this.tls_excluded_theme_ids.length
  }
}
